import { EActivityEventType, ETripEvent } from 'detailsv2/structure';
import i18n from 'i18n';

import { transformTime } from '../../../functions';
import { IDayTripEvent } from '../../../types';
import { EventOptionConfig } from '../../types';

const ActivityOption = ({ data, timeFormat }: IDayTripEvent<ETripEvent.Activity> & EventOptionConfig) => {
  const { title, type, time } = data;
  const symbol = (time.start && time.end && ' - ') || (time.start && !time.end && ' · ');

  switch (type) {
    case EActivityEventType.CustomTime:
    case EActivityEventType.Meal:
      return (
        <div>
          {transformTime(time.start, timeFormat)} {symbol}{' '}
          {time.end && time.start ? `${transformTime(time.end, timeFormat)} · ` : ''}
          <span data-block>{title}</span>
        </div>
      );

    case EActivityEventType.HalfDay:
    case EActivityEventType.FullDay:
      return (
        <div>
          {transformTime(time.start, timeFormat)} {symbol}{' '}
          {time.end && time.start ? `${transformTime(time.end, timeFormat)} · ` : ''}
          <span data-block>
            {i18n.t(`proposal_content.event_details.activities.activity.${type}`)} - {title}
          </span>
        </div>
      );
    default:
      return <div data-block>{title}</div>;
  }
};

export default ActivityOption;
